import MainLayout from '@/common/components/layouts/MainLayout';
import LoadingPage from '@/common/pages/LoadingPage';
import IncidentDetailMainDetailCard from '@/modules/adjusterReportModules/IncidentDetails/components/incidentDetails/incidentDetailMainDetailCard';
import useIncidentDetailsInitial from '@/modules/adjusterReportModules/IncidentDetails/pages/initialVisitDetails/incidentDetailsInitial.biz';
import { css } from 'styled-system/css';
import { Box } from 'styled-system/jsx';

export const IncidentShowDetailsInitial = () => {
  return (
    <MainLayout header="titleHeader" title="مشخصات بازدید" hasBottomPadding>
      <IncidentShowDetailsInitialPage />
    </MainLayout>
  );
};

const IncidentShowDetailsInitialPage = () => {
  const { incidentDetailsInitialData, incidentDetailsPending } =
    useIncidentDetailsInitial();

  if (incidentDetailsPending) return <LoadingPage />;
  return (
    <Box pt={25}>
      <IncidentDetailMainDetailCard
        fileNumber={incidentDetailsInitialData?.order_id!}
        fileType={incidentDetailsInitialData?.file_type.const!}
        svgColor="colors.blue"
        items={incidentDetailsInitialData?.detailCardItems!}
        hasBullet={true}
        backgroundColor="blue-1"
        headerClassName={css({ borderColor: 'blue-1' })}
      />
    </Box>
  );
};
